<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>액션 시민 그룹</h2>
            </div>

            <div class="sch_condition_wrap" style="margin-top: 5px">
                <div class="left">
                    <div class="select_tab_box_wrap">
                        <span class="sch_list_tit">상태값</span>
                        <div class="select_tab_box _130">
                            <div
                                class="selected_tab"
                                :class="[state.isShowSearchType ? 'active' : '']"
                                @click="state.isShowSearchType = !state.isShowSearchType"
                            >
                                <span>{{ search.searchType.name }}</span>
                            </div>
                            <div class="tab_option">
                                <button
                                    v-for="item in selectOption"
                                    @click="
                                        search.searchType = item;
                                        state.isShowSearchType = false;
                                        getList();
                                    "
                                >
                                    {{ item.name }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="select_tab_box_wrap">
                        <span class="sch_list_tit">활동 기간</span>
                        <div class="select_date_wrap">
                            <div class="select_date">
                                <input type="date" @keydown.enter="searchDate" name="" id="" v-model="search.startDate" @change="getList" />
                            </div>
                            <div class="select_date">
                                <input
                                    style="margin-left: 5px"
                                    type="date"
                                    @keydown.enter="searchDate"
                                    name=""
                                    id=""
                                    v-model="search.endDate"
                                    @change="getList"
                                />
                            </div>
                            <div class="search_wrap" style="width: 400px; margin-left: 10px">
                                <input type="text" v-model="search.keyword" @keyup.enter="getList()" placeholder="제목을 입력하세요." />
                                <button type="button" class="search_btn icon_wrap" @click="getList()">
                                    <img src="img/search_btn.png" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <button type="button" class="default_btn _blue" @click="state.isShowActionModal = true">등록</button>
                    <button type="button"><img src="img/excel_icon.png" @click="excelDownload" alt=" 엑셀 다운로드" /></button>
                </div>
            </div>

            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 80px" />
                        <col />
                        <col style="width: 160px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 90px" />
                        <col style="width: 90px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 80px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>번호</th>
                            <th>제목</th>
                            <th>활동 기간</th>
                            <th>등록일</th>
                            <th>출석 회차</th>
                            <th>액션활동 주차</th>
                            <th>모집인원</th>
                            <th>평균 참여 인원</th>
                            <th>상태</th>
                            <th>액션활동관리</th>
                            <th>상세</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td class="list_num cnt">{{ (state.currentPage - 1) * state.perPage + (idx + 1) }}</td>
                                <td>{{ item.title }}</td>
                                <td class="cnt">
                                    {{ CommonUtils.dateFormatYYMMDD(new Date(item.startDate)) }} ~
                                    {{ CommonUtils.dateFormatYYMMDD(new Date(item.endDate)) }}
                                </td>
                                <td class="cnt">{{ CommonUtils.dateFormatYYMMDD(new Date(item.createDate)) }}</td>
                                <td class="cnt">{{ item.cntRound }}</td>
                                <td class="cnt">{{ item.cntState }}</td>
                                <td class="cnt">{{ item.cntCitizen }}</td>
                                <td class="cnt">{{ item.avgCntEntireForRound }}</td>
                                <td class="cnt">
                                    <button v-if="item.state === 1" class="default_btn _blue" @click="stateChange(item)">진행중</button>
                                    <button v-else class="default_btn _gray" @click="stateChange(item)">종료</button>
                                </td>
                                <td class="cnt">
                                    <!-- /action/{액션 그룹 idx}/state -->
                                    <button class="default_btn _blue" @click="router.push(`/action/${item.idx}/state`)">관리</button>
                                </td>
                                <td class="cnt">
                                    <!-- /action/group/{액션 그룹 idx} -->
                                    <button class="default_btn _blue" @click="router.push(`/action/group/${item.idx}`)">상세</button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="11"><div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                :currentPage="state.currentPage"
                :totalLength="state.totalLength"
                :perPage="state.perPage"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="modal.tab"
        :title="modal.title"
        :content="modal.content"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>

    <ActionGroupModal v-if="state.isShowActionModal" @close="state.isShowActionModal = false" @callback="closeActionModal"></ActionGroupModal>
</template>
<script lang="ts" config>
    import {
        reactive,
        onMounted,
        Header,
        Left,
        ModalDefault,
        AdminManageModal,
        onBeforeUnmount,
        PageBtn,
        CommonUtils,
        router,
        apiService,
        types,
        getMessageByCode,
        ActionGroupModal,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, AdminManageModal: AdminManageModal, ActionGroupModal },
        setup() {
            const state = reactive({
                isShowSearchType: false as boolean,
                isShowModal: false as boolean,
                isShowActionModal: false as boolean,

                isCheckAll: false as boolean,
                checkedList: [] as number[],

                list: [] as types.ResActionGroupDetailForApi[],

                totalLength: 0 as number,
                perPage: 10 as number,
                currentPage: 1 as number,

                selectStateIdx: 0 as number,
            });

            const modal = reactive({
                title: "" as string,
                content: "" as string,
                tab: 0 as number,
            });

            const search = reactive({
                startDate: "",
                endDate: "",
                keyword: "",
                searchType: { name: "전체", key: null } as { name: string; key: number | null },
            });

            const selectOption = [
                { name: "전체", key: null },
                { name: "진행중", key: 1 },
                { name: "종료", key: 0 },
            ];

            onMounted(() => {
                getList();
            });

            const getList = async () => {
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    searchType: search.searchType.key,
                    searchText: search.keyword,
                    startDate: search.startDate,
                    endDate: search.endDate,
                    state: search.searchType.key,
                } as types.ReqActionGroupList;
                const res = await apiService.actionGroup.list(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                } else {
                    state.list = [];
                }
            };

            const searchDate = () => {
                if (search.endDate && search.startDate && search.endDate < search.startDate) {
                    search.endDate = "";
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                    return;
                }
                search.startDate = search.startDate;
                search.endDate = search.endDate;
                // state.page = 1;
                getList();
            };

            const toggleAll = () => {};

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getList();
            };

            const callBackModal = (param: any) => {
                if (param.action === "confirm") {
                    toggleState(state.selectStateIdx);
                }
                state.isShowModal = false;
            };

            const closeActionModal = () => {
                state.isShowActionModal = false;
                getList();
            };

            const stateChange = (item: types.ResActionGroupDetailForApi) => {
                if (item.state === 1) {
                    modal.tab = 5;
                    modal.title = "알림";
                    modal.content = "액션 시민 그룹을 종료 하시겠습니까?";
                    state.selectStateIdx = item.idx;
                    state.isShowModal = true;
                } else toggleState(item.idx);
            };

            const toggleState = async (idx: number) => {
                const res = await apiService.actionGroup.change(idx);
                if (res.returnCode === 0) {
                    getList();
                } else {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                }
            };

            const excelDownload = async () => {
                try {
                    const param = {
                        idxList: "",
                        page: state.currentPage,
                        size: state.perPage,
                        searchType: search.searchType.key,
                        searchText: search.keyword,
                        state: search.searchType.key,
                        startDate: search.startDate,
                        endDate: search.endDate,
                    } as types.ReqActionGroupForExcel;
                    const res = await apiService.actionGroup.excelDownload(param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        modal.tab = -1;
                        modal.title = "알림";
                        modal.content = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            return {
                CommonUtils,
                router,
                state,
                modal,
                search,
                selectOption,
                searchDate,
                toggleAll,
                handlePageChange,
                callBackModal,
                stateChange,
                closeActionModal,
                getList,
                excelDownload,
            };
        },
    };
</script>
<style scoped>
    .sch_condition_wrap > div.right {
        align-items: flex-end;
    }
</style>
